<template>
  <div id="app">
    <info />

    <div class="py-20 container mx-auto grid ">
      <div class="grid gap-6 mb-8 md:grid-cols-3 xl:grid-cols-3 mx-auto  max-w-7xl">
        <div
          class="flex items-center text-center p-4 bg-white rounded-lg shadow-xs dark:bg-gray-800"
        >
          <div>
            <p
              class="mb-2 text-sm font-medium text-gray-600 dark:text-gray-400"
            >
              1 LCF
            </p>
            <p class="text-lg font-semibold text-gray-700 dark:text-gray-200">
              {{ showBUSD }} BUSD
            </p>
          </div>
        </div>

        <div
          class="flex items-center text-center	 p-4 bg-white rounded-lg shadow-xs dark:bg-gray-800"
        >
          <div>
            <p
              class="mb-2 text-sm font-medium text-gray-600 dark:text-gray-400"
            >
              1 BUSD
            </p>
            <p class="text-lg font-semibold text-gray-700 dark:text-gray-200">
              {{ showLCF }} LCF
            </p>
          </div>
        </div>

        <div
          class="flex items-center text-center	 p-4 bg-white rounded-lg shadow-xs dark:bg-gray-800"
        >
          <div>
            <p
              class="mb-2 text-sm font-medium text-gray-600 dark:text-gray-400"
            >
              Total Supply
            </p>
            <p class="text-lg font-semibold text-gray-700 dark:text-gray-200">
              {{ supply }} LCF
            </p>
          </div>
        </div>
      </div>
    </div>

    <foot />
  </div>
</template>

<script>
import { ethers } from "ethers";
import { formatEther, parseEther } from "ethers/lib/utils";

import tokenAbi from "./assets/token.json";
import routerAbi from "./assets/router.json";

const tokenaddr = "0x4c602f5f89063cea006cf532cc38a58c2f73ed9e";
const busdaddr = "0xe9e7cea3dedca5984780bafc599bd69add087d56";
const routeraddr = "0x10ed43c718714eb63d5aa57b78b54704e256024e";

var provider = new ethers.providers.JsonRpcProvider(
  "https://bsc-dataseed.binance.org/"
);

const lcf = new ethers.Contract(tokenaddr, tokenAbi, provider);
const router = new ethers.Contract(routeraddr, routerAbi, provider);

import info from "@/components/info";
import foot from "@/components/foot";

export default {
  name: "App",
  components: {
    info,
    foot,
  },
  data: function() {
    return {
      showBUSD: 0,
      showLCF: 0,
      supply: 0,
    };
  },
  async mounted() {
    const amountsOut = await router.getAmountsOut(parseEther("1.0"), [
      tokenaddr,
      busdaddr,
    ]);

    this.showBUSD = parseFloat(formatEther(amountsOut[1])).toFixed(10);

    const amountsOut2 = await router.getAmountsOut(parseEther("1.0"), [
      busdaddr,
      tokenaddr,
    ]);

    this.showLCF = parseFloat(formatEther(amountsOut2[1])).toFixed(10);

    const checkupply = await lcf.totalSupply();

    this.supply = parseFloat(formatEther(checkupply)).toFixed(2);
  },
};
</script>
